


import React, { Fragment } from "react";
import { useMapresource } from "../data/useMapresource";
import { IMapresource } from "../models/Mapresource";

type IRenderProps = {
    mapresource: IMapresource | null
};

interface RenderMapresourceProps {
    tilesetUrl: string;
    render: (props: IRenderProps) => any;
};

export const RenderMapresource: React.FC<RenderMapresourceProps> = ({ tilesetUrl, render }) => {
    const { data: mapresource } = useMapresource(tilesetUrl);
    return (
        <Fragment>
            {render({ mapresource })}
        </Fragment>
    );
};

